import { render } from "./UserAssetItem.vue?vue&type=template&id=3c89b1fa&scoped=true&ts=true"
import script from "./UserAssetItem.vue?vue&type=script&lang=ts"
export * from "./UserAssetItem.vue?vue&type=script&lang=ts"

import "./UserAssetItem.vue?vue&type=style&index=0&id=3c89b1fa&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c89b1fa"]])

export default __exports__